import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import Modal from '../../../components/UI/Modal/Modal'
import {
    Row, Col, Form, FormGroup, Input, Button, Label
} from 'reactstrap';
import ReactPaginate from 'react-paginate';

import {
    fetchPortfolioDetails,
    searchPortfolio,
    fetchRiskLevels,
    fetchProductNameFilterList,
    fetchRiskScoreTrendFilter,
    fetchCaseStatusFilter,
    fetchBusinessSegmentFilter,
    fetchLegalConstitutionFilter,
    fetchProductTypeDetails,
    searchPortfolioSuccess,
    setPortfolioFilters,
    fetchCaseType,
    getSelectedCompanyName
} from '../action';
// import Modal from '../../components/UI/Modal/Modal';
import { viewSelectedCounterparty } from '../../corporate/action';
import { setFilters } from '../../dashboard/action';
import { Preloading } from '../../../components/UI/Preloader/action';
import BuyForm from '../../search-result/View/BuyForm/index'
import { getCounterpartyType, getZone } from '../../../Analyst/Cases/Create/actions'
import PortfolioTable from './Table';
import * as PortfolioConstants from '../constants';
import { goolgeAnalyticsEvents, setPageView } from '../../../components/GoogleAnalytics/index';
import { MODAL_TYPE_SUCCESS, MODAL_TYPE_FORM } from '../../../constants';
import {
    appliedPortfolioFilters, filterValueListRemove, 
    deleteAppliedFilterList, SearchRequestBody, portfolioDataHandle, 
    checkAllCheckboxMethod, setInitialValues, pageLink, currentLink, 
    paginatedRequestBody, createFilterUrl, getUrlFilter
} from '../helper';
import { ProductTypesPop } from '../../productTypesPop';
import CorporateModal from '../../../components/UI/CorporateModal/index';
import FilterForm from './FilterForm';
import DropdownSelect from '../../../components/Dropdown/index';    
import withRouter from '../../../withRouter';


class CasePortfolio extends Component{
    constructor(props) {
        super(props);
        this.state = {
            popoverOpen: false,
            appliedFilters: this.props.portfolioFilters,
            appliedFiltersList: [],
            clearAllButton: null,
            clearFlag: false,
            toDate: null,
            fromDate: null,
            portfolioData: [],
            sortFlag: true,
            showModal: false,
            body: null,
            modalType: MODAL_TYPE_FORM,
            modalTitle: '',
            showBuyButtons: false,
            modalCloseHandler: () => { },
            checkedAll: false,
            initialValues: {},
            selectedPortfolioData: [],
            zoneList: [],
            currentPage: parseInt(this.props.urlPageNumber) - 1,
            sortType: PortfolioConstants.SORT_TYPE_DESCENDING,
            sortField: PortfolioConstants.DEFAULT_SORT_FIELD,
            searchText: '',
            selectedCountry: '',
            selectedState: [],
            reportCategory : this.props.reportCategory,
            selectedSearchType: PortfolioConstants.SEARCH_PARAMETERS[0],
            selectedComputedReportId: null,
        };
    }

    componentDidMount() {
        setPageView('/Corporate/Portfolio', '/case-portfolio');
        const urlFilters = getUrlFilter(this.props.urlSearch);
        this.filterFormCallback(urlFilters, urlFilters.toDate, urlFilters.fromDate, urlFilters.selectedCountry, urlFilters.selectedState, false);
    }

    componentDidUpdate(prevProps) {
        const { portfolioListData, productTypeDetails, createCase, portfolioListFailure ,result, selectedCounterParty} = this.props
        if (this.props.urlPageNumber !== prevProps.urlPageNumber || this.props.urlSearch !== prevProps.urlSearch) {
            this.setState({
                currentPage: parseInt(this.props.urlPageNumber - 1)
            }, () => {
                this.props.preloading(true);
                const urlFilters = getUrlFilter(this.props.urlSearch)
                this.filterFormCallback(urlFilters, urlFilters.toDate, urlFilters.fromDate, urlFilters.selectedCountry, urlFilters.selectedState, false);
            });
        }
        if (this.props.zoneList !== prevProps.zoneList) {
            this.setState({
                zoneList: this.props.zoneList
            })
        }
        if (!createCase.error && createCase !== prevProps.createCase) {
            this.props.preloading(false);
            toast.success(
                <div>
                    <i className="fa fa-check text-large-150"></i>&nbsp;Case Successfully Created!
                </div>
            );
            this.props.fetchPortfolioDetails();

        }
        else if (createCase.error && createCase !== prevProps.createCase) {
            this.props.preloading(false);
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle text-large-150"></i>&nbsp;{(createCase.error.response && createCase.error.response.data) ? createCase.error.response.data.message : "Something went wrong! Please try again."}
                </div>
            );
        }
        if (portfolioListData !== prevProps.portfolioListData) {
            this.setPortfolioData();
        }
        if (portfolioListFailure !== prevProps.portfolioListFailure) {
            this.props.preloading(false);
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle text-large-150"></i>&nbsp;{(portfolioListFailure.response && portfolioListFailure.response.data) ? portfolioListFailure.response.data.message : "Something went wrong! Please try again."}
                </div>
            );
            this.setState({
                portfolioData: []
            })

        }
        if (productTypeDetails !== prevProps.productTypeDetails) {
            this.setState(prevState => ({
                showModal: !prevState.showModal,
                body:
                    <ProductTypesPop productTypes={productTypeDetails} />,
                modalType: MODAL_TYPE_SUCCESS,
                modalTitle: 'Subscribed Products',
                modalCloseHandler: this.toggleModal
            }))
        }
        if (selectedCounterParty != prevProps.selectedCounterParty){
            this.props.preloading(false)
        }
    }

    toggleModal = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            body: null
        }));
    }

    

    filterFormCallback = (filterFormData, toDate, fromDate, selectedCountry, selectedState, popoverFlag) => {
        let initialVal = {}
        if (filterFormData) {
            const appliedTempFilters = appliedPortfolioFilters(filterFormData, toDate, fromDate, selectedCountry, selectedState);
            this.setState({
                appliedFilters: filterFormData,
                appliedFiltersList: appliedTempFilters,
                toDate: toDate,
                fromDate: fromDate
            }, () => {
                this.setState({
                    selectedCountry: selectedCountry,
                    selectedState: selectedState
                })
            })

            if (appliedTempFilters.length > 0) {
                this.setState({
                    clearAllButton: <Button className="filter-item filter-item-btn-clear" color="link" size="xs" onClick={this.handleClearAll}>Clear All</Button>,
                    selectedCountry:''
                })
            }
            this.props.preloading(true)
            // this.props.setPortfolioFilters(filterFormData);
            const searchRequest = SearchRequestBody('','', filterFormData, toDate, fromDate, selectedCountry, selectedState,this.state.reportCategory, this.props.withoutRiskScore);
            const requestBody = paginatedRequestBody(this.state.currentPage, PortfolioConstants.PAGE_SIZE, this.state.sortField, this.state.sortType, searchRequest)
            this.props.searchPortfolio(requestBody);
            // goolgeAnalyticsEvents('Corporate', 'Apply Portfolio Filters', 'Portfolio Filters', '');
            if (popoverFlag) {
                this.toggle();
                goolgeAnalyticsEvents('Corporate', 'Apply Portfolio Filters', 'Portfolio Filters', '');
                // this.props.history.push(`./${1}`)
                const url = createFilterUrl(filterFormData, toDate, fromDate, selectedCountry, selectedState);
                this.props.history.push(`?${url}`);
            } else {
                appliedTempFilters.forEach((item, index, element) => {
                    initialVal[item] = true
                });
                this.setState({
                    initialValues: {
                        ...initialVal
                    }
                })
            }

        } else {
            this.setState(prevState => ({
                initialValues: {},
                appliedFilters: [],
                appliedFiltersList: [],
                clearAllButton: null,
                toDate: null,
                fromDate: null
            }))
        }

    }
    handleClearAll = () => {
        this.setState(prevState => ({
            initialValues: {},
            appliedFilters: [],
            appliedFiltersList: [],
            clearAllButton: null,
            clearFlag: !prevState.clearFlag,
            toDate: null,
            fromDate: null,
            currentPage: 0,
            selectedCountry: '',
            selectedState: ''
        }))
        this.props.history.push(`/my-portfolio/${1}`)
        this.props.setPortfolioFilters([]);
        this.props.setFilters([]);
        this.props.preloading(true);
        const requestBody = paginatedRequestBody(0, PortfolioConstants.PAGE_SIZE, PortfolioConstants.DEFAULT_SORT_FIELD, PortfolioConstants.SORT_TYPE_DESCENDING, PortfolioConstants.DEFAULT_REQUEST_BODY)
        this.props.searchPortfolio(requestBody);
        // this.props.fetchPortfolioDetails();
    }
    handleRemoveFilter = (removeFilterListData) => {
        this.props.preloading(true)
        const removedFilterList = filterValueListRemove(removeFilterListData, this.state.appliedFiltersList)
        const appliedFiltersDelete = deleteAppliedFilterList(removeFilterListData, this.state.appliedFilters)
        if (removedFilterList.length === 0) {
            this.handleClearAll();
        } else {
            let initialVal = {}, toDate = this.state.toDate, fromDate = this.state.fromDate;
            if (removeFilterListData.date) {
                this.setState({
                    toDate: null,
                    fromDate: null
                })
                toDate = null;
                fromDate = null;
            }
            removedFilterList.forEach((item, index, element) => {
                initialVal[item] = true
            })
            this.setState(prevState => ({
                appliedFiltersList: removedFilterList,
                appliedFilters: appliedFiltersDelete,
                selectedCountry: '',
                selectedState: '',
                initialValues: {
                    ...initialVal
                }
            }));
            this.props.setPortfolioFilters(appliedFiltersDelete);
            /*             if (Object.keys(this.props.dashBoardFilters).length > 0) {
                            this.props.setDashboardFilters()
                        } */
            const searchRequest = SearchRequestBody('','', appliedFiltersDelete, toDate, fromDate, '','',this.state.reportCategory, this.props.withoutRiskScore)
            const requestBody = paginatedRequestBody(0, PortfolioConstants.PAGE_SIZE, this.state.sortField, this.state.sortType, searchRequest)
            this.props.searchPortfolio(requestBody);
            // this.props.history.push(`${1}`);
            const url = createFilterUrl(appliedFiltersDelete, toDate, fromDate);
            this.props.history.push(`/my-portfolio/${1}?${url}`);
        }
    }

    handleBuyAction = (value) => {
        goolgeAnalyticsEvents('Corporate', 'Buy Individual Report', 'Buy Report', '');
        let zonesSelected = [];
        let zonetoSelect =  null;
        this.props.viewSelectedCounterparty(value)
        for (let i = 0; i < this.props.zoneList.length; i++) {
            if (this.props.zoneList[i].name === value.zoneName) {
                zonesSelected.push({ id: this.props.zoneList[i].id, name: this.props.zoneList[i].name })
                zonetoSelect = {zoneId: this.props.zoneList[i].id, zone: this.props.zoneList[i].name }
                break;
            }
        }
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            body: <BuyForm toggle={this.toggleModal} selectedvalue={value.counterpartyType} zoneSelected={zonesSelected} zoneForState={zonetoSelect} buyFormType={PortfolioConstants.PORTFOLIO_BUY} />,
            modalType: MODAL_TYPE_FORM,
            modalTitle: 'Buy report for - ' + value.counterpartyName,
            modalCloseHandler: this.toggleModal
        }))
    }

    dashBoardFiltersUpdate = (dashBoardFilters, toDate, fromDate) => {
        const appliedTempFilters = appliedPortfolioFilters(dashBoardFilters, toDate, fromDate);
        this.setState({
            appliedFilters: dashBoardFilters,
            appliedFiltersList: appliedTempFilters,
            toDate: toDate,
            fromDate: fromDate,
            // currentPage: this.props.match.params.pageNumber,
            initialValues: setInitialValues(dashBoardFilters),
            clearAllButton: <Button className="filter-item filter-item-btn-clear" color="link" size="xs" onClick={this.handleClearAll}>Clear All</Button>
        });

        // this.props.setFilters(null);
        this.props.preloading(true);
        this.props.setPortfolioFilters(dashBoardFilters);
        const requestBody = paginatedRequestBody(this.state.currentPage, PortfolioConstants.PAGE_SIZE, this.state.sortField, this.state.sortType, dashBoardFilters)
        this.props.searchPortfolio(requestBody);
    }

    handleSearchChange = (event) => {
        
        if (event.key === PortfolioConstants.ENTER) {
            this.props.preloading(true)
            event.preventDefault()
            const searchRequest = SearchRequestBody(this.state.selectedSearchType,event.target.value, this.state.appliedFilters, this.state.toDate, this.state.fromDate, '','',this.state.reportCategory, this.props.withoutRiskScore)
            const requestBody = paginatedRequestBody(0, PortfolioConstants.PAGE_SIZE, this.state.sortField, this.state.sortType, searchRequest)
            this.props.searchPortfolio(requestBody);
            this.setState({
                searchText: event.target.value
            })
            setPageView('/Corporate/portfolio', event.target.value);
        }
    }
    sortByPortfolioDataKey = (key) => {
        let sortDirection;
        if (this.state.sortType === PortfolioConstants.SORT_TYPE_DESCENDING) {
            sortDirection = PortfolioConstants.SORT_TYPE_ASCENDING
        } else {
            sortDirection = PortfolioConstants.SORT_TYPE_DESCENDING
        }
        this.setState({
            sortField: key,
            sortType: sortDirection
        })
        this.props.preloading(true)
        const searchRequest = SearchRequestBody(this.state.selectedSearchType,this.state.searchText, this.state.appliedFilters, this.state.toDate, this.state.fromDate, '','',this.state.reportCategory, this.props.withoutRiskScore)
        const requestBody = paginatedRequestBody(0, PortfolioConstants.PAGE_SIZE, key, sortDirection, searchRequest)
        this.props.searchPortfolio(requestBody);

    }
    handleCheckChildElement = (event) => {
        let tempPortfolioData = [...this.state.portfolioData];
        let tempSelectedPortfolioData = [...this.state.selectedPortfolioData];
        let tempFlag = false;
        tempPortfolioData.forEach((value, index, element) => {
            if (event.target.checked === true) {
                if (value.id === event.target.value) {
                    value.isChecked = event.target.checked
                    tempSelectedPortfolioData.push(value);
                    this.setState({
                        selectedPortfolioData: tempSelectedPortfolioData
                    })
                }
            } else {
                if (value.id === event.target.value) {
                    value.isChecked = event.target.checked
                    tempSelectedPortfolioData.forEach((item, i, selectedData) => {
                        if (value.id === item.id) {
                            tempSelectedPortfolioData.splice(i, 1);
                        }
                    })
                    this.setState({
                        selectedPortfolioData: tempSelectedPortfolioData
                    })
                }
            }
        })

        const checkAllCheckbox = checkAllCheckboxMethod(tempPortfolioData)
        if (checkAllCheckbox) {
            tempFlag = true
        }
        this.setState({
            portfolioData: tempPortfolioData,
            checkedAll: tempFlag
        })
    }

    handleAllChecked = (event) => {
        let tempPortfolioData = [...this.state.portfolioData]
        tempPortfolioData.forEach(value => value.isChecked = event.target.checked)
        this.setState({ selectedPortfolioData: tempPortfolioData, checkedAll: event.target.checked })
    }
    productDescriptionModal = () => {
        goolgeAnalyticsEvents('Corporate', 'Portfolio Report Type Details', 'Report Type Details', '');
        this.props.fetchProductTypeDetails()
    }

    handlePagination = (pageNo) => {
        goolgeAnalyticsEvents('Corporate', 'Update Portfolio Table Page Number', 'Portfolio Pagination', pageNo + 1);
        const searchRequest = SearchRequestBody('','',
            this.state.appliedFilters,
            this.state.toDate,
            this.state.fromDate,
            '',
            '',
            this.state.reportCategory, 
            this.props.withoutRiskScore
        );
        // this.props.history.push(`./${pageNo + 1}`)
        this.props.preloading(true)
        const requestBody = paginatedRequestBody(pageNo, PortfolioConstants.PAGE_SIZE, this.state.sortField, this.state.sortType, searchRequest )
        this.setState({
            currentPage: pageNo
        });
        this.props.searchPortfolio(requestBody);
        const url = createFilterUrl(this.state.appliedFilters, this.state.toDate, this.state.fromDate);
        this.props.history.push(`/my-portfolio/${pageNo + 1}?${url}`) 

    }

    handleSelectedBuy = (counterpartyId, coumputedReportId) => {
        this.props.preloading(true)
        this.props.viewSelectedCounterparty(counterpartyId)
        if(this.state.selectedComputedReportId == coumputedReportId){
            this.setState({
                showBuyButtons: !this.state.showBuyButtons
            });
         }else{
            this.setState({
                showBuyButtons: true, selectedComputedReportId: coumputedReportId
            });
         }
    }
    
    
    setPortfolioData = () => {
        let actionButton = null
        let tempPortfolioData = portfolioDataHandle(this.props.portfolioListData.portfolioRowViewList)
        this.props.portfolioListData.portfolioRowViewList.forEach((item, index, element) => {
            (item.status[0] === PortfolioConstants.CREATE) ?
               actionButton = <div><Button color="primary" className="mr-2" key={tempPortfolioData[index].computedReportId}  onClick={() => this.handleSelectedBuy(tempPortfolioData[index].counterpartyId, tempPortfolioData[index].computedReportId)}><i className="fa fa-shopping-cart"></i></Button>
               <Link to={`/credit-worthiness/${tempPortfolioData[index].counterpartyId}/${tempPortfolioData[index].counterpartyType}/${tempPortfolioData[index].computedReportId}`}>
                <Button color="primary" ><i className="fa fa-eye" aria-hidden="true" ></i></Button></Link>
               </div>:
                actionButton = item.status
                tempPortfolioData[index].status = actionButton
        }) 
        this.setState({
            portfolioData: tempPortfolioData
        });     
        this.props.preloading(false)
    }
    
    toggle = () => {
        this.setState(prevState => ({
            popoverOpen: !prevState.popoverOpen
        }));
    }

    handleToggle = () => {
        this.setState((prevState) => ({
          isOpen: !prevState.isOpen
        }))
      }

    dropdownCallback = (data) => {
        this.setState({
          selectedSearchType: data
        })
      }

    getSelectedCompanyName=(name)=>{
        this.props.getSelectedCompanyName({companyName: name});
    }
   
    render() {
        return (           
            <div className="mt-2">
                <pre>
                    <i className="icon-info mr-1"></i>Case Portfolio displays the Rubix Business Check Reports for your portfolio companies.
                </pre>
                <CorporateModal toShow={this.state.showModal}
                                modalClosed={this.state.modalCloseHandler}
                                modalType={this.state.modalType}
                                body={this.state.body}
                                title={this.state.modalTitle} />
                <Modal show={this.state.showModal} modalClosed={this.handleToggle} >
                    {this.state.body}
                </Modal>

                <Row className="d-flex justify-content-between no-gutters mb-3 position-relative">
                
                <DropdownSelect dropdownValues={PortfolioConstants.SEARCH_PARAMETERS} handleDropdown={this.dropdownCallback} selectedSearchType={this.state.selectedSearchType} dropdownOpen={this.state.isOpen} toggle={this.handleToggle} />
                    <Form className="form-search col-24 col-sm-8 mb-3 mb-sm-0">
                        <FormGroup className="mb-0 input-search">
                            <i className="icon-search position-absolute search-icon-color" style={{ '--primaryColor': this.props.corporateColor.colorHexCode }}></i>
                            <Input className="bg-light" type="search" name="search" id="search" onKeyPress={this.handleSearchChange} placeholder="Search within case portfolio" autoComplete="off" />
                        </FormGroup>
                    </Form>
                    <div className="filter-wrapper ml-auto">
                        <div>
                            <Button id="Popover1" className={this.state.popoverOpen ? 'btn-filter btn-icon filter-popover-open' : 'btn-filter btn-icon filter-popover-close'} outline size="sm" style={{ '--primaryColor': this.props.corporateColor.colorHexCode }} onClick={this.toggle}>
                                <i className="icon-filter"></i>
                            </Button>
                        </div>
                    </div>
                    <div className={this.state.popoverOpen ? "position-absolute filter-popover d-block bg-light p-4" : "position-absolute filter-popover d-none p-3"}>
                        <FilterForm
                            counterPartyData={this.props.counterPartyData}
                            zoneList={this.state.zoneList}
                            riskLevel={this.props.riskLevel}
                            reportType={this.props.reportType}
                            businessSegment={this.props.businessSegment}
                            legalConstitution={this.props.legalConstitution}
                            riskTrend={this.props.riskTrend}
                            caseStatus={this.props.caseStatus}
                            initialValues={this.state.initialValues}
                            filterFormCallback={this.filterFormCallback}
                            hidePortfolioFiltersCallback={this.toggle}
                            clearAll={this.state.clearFlag}
                            toDate={this.state.toDate}
                            fromDate={this.state.fromDate}
                            corporateColor={this.props.corporateColor.colorHexCode}
                            selectedCountry={this.state.selectedCountry}
                            selectedState={this.state.selectedState}
                            caseType={this.props.caseType}
                            
                        />
                    </div>
                </Row>
                
                <div className="no-gutters mb-3 d-flex flex-column flex-sm-row">
                    <Label className="filter-title col-sm-3 pr-0">Applied Filters :</Label>
                    <div className="col-sm-21 pl-0 filter d-flex flex-wrap align-items-center">
                        {(this.state.appliedFiltersList.length > 0) ? this.state.appliedFiltersList.map(p => {
                            let tempFilter, tempFilterKey;
                            if (p.date) {
                                tempFilter = p.date[1].label + ' - ' + p.date[0].label
                                tempFilterKey = p.date[1].key + '-' + p.date[0].key
                            } else {
                                tempFilterKey = p;
                                tempFilter = p;
                            }
                            return (
                                <span key={tempFilterKey} className="filter-item d-flex align-items-center mr-2 mb-2">
                                    {tempFilter} <i className="icon-close pointer" onClick={() => this.handleRemoveFilter(p)}></i>
                                </span>
                            )
                        }) : ''}
                        {this.state.clearAllButton}
                    </div>
                </div>

                <Row noGutters className="mb-3 custom-table-header d-none d-sm-flex align-items-center">
                    <Col sm="1" className="custom-table-header-title p-3">
                        <div className="custom-control custom-checkbox">
                            <input type="checkbox" className="custom-control-input m-0" checked={this.state.checkedAll} onChange={e => {}} value="checkedAll" onClick={this.handleAllChecked} id="customCheck1" />
                            <label style={{ '--primaryColor': this.props.corporateColor.colorHexCode }} className="custom-control-label cursor-pointer" htmlFor="customCheck1">&nbsp;</label>
                        </div>
                    </Col>
                    <Col sm="23" className="px-2">
                        <Row noGutters className="align-items-center">
                            <Col sm={this.state.reportCategory !== PortfolioConstants.INVESTIGATED ? "6":"3"} className="custom-table-header-title px-2 py-3" onClick={() => this.sortByPortfolioDataKey('counterpartyName')}>Company Name <i className={(this.state.sortField === 'counterpartyName') ? "icon-updown" : ''}></i></Col>
                            <Col sm="3" className="custom-table-header-title px-2 py-3" onClick={() => this.sortByPortfolioDataKey('counterpartyType')}>Counterparty Type <i className={(this.state.sortField === 'counterpartyType') ? "icon-updown" : ''}></i></Col>
                            <Col sm="4" className="custom-table-header-title px-2 py-3" >Identifiers</Col>
                            {
                                this.state.reportCategory === PortfolioConstants.INVESTIGATED && <Col sm="2" className="custom-table-header-title px-2 py-3 text-sm-center d-flex align-items-center cursor-pointer" onClick={() => this.sortByPortfolioDataKey('riskScore')}>Rubix Risk Score <i className={(this.state.sortField === 'riskScore') ? "icon-updown" : ''}></i></Col>
                            }
                            {
                                this.state.reportCategory === PortfolioConstants.INVESTIGATED && <Col sm="3" className="custom-table-header-title px-2 py-3 text-sm-center cursor-pointer" title="Risk Level" onClick={() => this.sortByPortfolioDataKey('riskLevel')}>Risk Level<i className={(this.state.sortField === 'riskLevel') ? "icon-updown" : ''}></i></Col>
                            }
                            <Col sm="3" className="custom-table-header-title px-2 py-3 cursor-pointer" >Report Type</Col>
                            <Col sm="3" className="custom-table-header-title px-2 py-3 cursor-pointer" onClick={() => this.sortByPortfolioDataKey('dueOrCompletedDate')}><span className='delivery-text'>Delivery /</span> <br /><i className="icon-in-progress"></i> &nbsp;Due Date <i className={(this.state.sortField === 'dueOrCompletedDate') ? "icon-updown" : ''}></i></Col>
                            <Col sm="3" className="custom-table-header-title p-3 text-sm-center">Action / Status</Col>
                        </Row>
                    </Col>

                </Row>

                <PortfolioTable corporateColor={this.props.corporateColor} 
                    portfolioData={this.state.portfolioData} handleCheckChildElement={this.handleCheckChildElement} 
                    productTypeDescription={this.productDescriptionModal} 
                    reportCategory={this.state.reportCategory}
                    selectedComputedReportId={this.state.selectedComputedReportId}
                    showBuyButtons={this.state.showBuyButtons}
                    portfolioListData={this.props.portfolioListData}
                    selectedCounterParty={this.props.selectedCounterParty}
                    selectedCounterPartyName={this.getSelectedCompanyName}
                    history={this.props.history}
                    />

                {this.props.portfolioListData && this.props.portfolioListData.numberOfPages > 0 &&
                <div className="paginate-portfolio">
                { 
                    (Object.keys(this.props.portfolioListData).length) ? <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        breakClassName={pageLink}
                        previousClassName={pageLink}
                        nextClassName={pageLink}
                        pageClassName={pageLink}
                        activeClassName={currentLink}
                        initialPage={this.state.currentPage}
                        pageCount={this.props.portfolioListData.numberOfPages}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={10}
                        onPageChange={i => {
                            this.handlePagination(i.selected)
                        }}
                        /> : ''
                }
                </div>}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    counterPartyData: state.createCase.dropdownData,
    zoneList: state.createCase.zoneList,
    riskLevel: state.portfolio.riskLevelSuccess,
    reportType: state.portfolio.productNameListSuccess,
    legalConstitution: state.portfolio.legalConstitutionSuccess,
    businessSegment: state.portfolio.businessSegmentSuccess,
    riskTrend: state.portfolio.riskTrendSuccess,
    caseStatus: state.portfolio.caseStatusSuccess,
    caseType: state.portfolio.caseTypeSuccess,
    portfolioFilters: state.portfolio.portfolioFilters,
    result: state.createCase.result,

    // fetchPortfolioDetails()  call responses
    portfolioListData: state.portfolio.portfolioList,
    fetchPortfolioDetailsFailure: state.portfolio.portfolioListFailure, // failure for fetchPortfolioDetails() & searchPortfolio()

    searchPortfolioData: state.portfolio.searchPortfolioSuccess,

    productTypeDetails: state.portfolio.productTypeDetails,
    productTypeDetailsFailure: state.portfolio.productTypeDetailsFailure,

    createCase: state.createCase.result,
    dashBoardFilters: state.dashboard.portfolioFilters,
    portfolioListFailure: state.portfolio.portfolioListFailure,

    corporateColor: state.corporate.corporateColor,
    cugPortfoliioList :state.cugPortfolio.cugPortfoliioList,
    selectedCounterParty: state.corporate.selectedCounterParty,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchPortfolioDetails: () => { dispatch(fetchPortfolioDetails()) },
    fetchCounterPartyType: () => { dispatch(getCounterpartyType()) },
    getZone: () => { dispatch(getZone()) },
    searchPortfolio: (data) => { dispatch(searchPortfolio(data)) },
    searchPortfolioSuccess: (data) => { dispatch(searchPortfolioSuccess(data)) },
    fetchRiskLevels: () => { dispatch(fetchRiskLevels()) },
    fetchProductNameFilterList: () => { dispatch(fetchProductNameFilterList()) },
    fetchRiskScoreTrendFilter: () => { dispatch(fetchRiskScoreTrendFilter()) },
    fetchCaseStatusFilter: () => { dispatch(fetchCaseStatusFilter()) },
    fetchBusinessSegmentFilter: () => { dispatch(fetchBusinessSegmentFilter()) },
    fetchLegalConstitutionFilter: () => { dispatch(fetchLegalConstitutionFilter()) },
    viewSelectedCounterparty: (data) => { dispatch(viewSelectedCounterparty(data)) },
    fetchProductTypeDetails: () => { dispatch(fetchProductTypeDetails()) },
    setFilters: (data) => { dispatch(setFilters(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    setPortfolioFilters: (filterData) => { dispatch(setPortfolioFilters(filterData)) },
    fetchCaseType: () => { dispatch(fetchCaseType()) },
    getSelectedCompanyName:(data)=>{dispatch(getSelectedCompanyName(data))}
});
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(CasePortfolio))